import { get, isEmpty } from 'lodash'
import { required, requiredCheck, email } from 'utils/validation'
import { CONFIGURATION_KEYS, HIERARCHY_LEVELS } from 'constants/enums'


const validate = (values, props = {}) => {
  let errors = {}

  const isVolunteerCodeOfConductEnabled = get(props, `configuration.values[${CONFIGURATION_KEYS.volunteerCodeOfConduct.id}].booleanValue`, false)

  const conductUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.auCoConductDoc.id}].fileUrl`)

  const isNaoRegRequirementEnabled = get(props, `configuration.values[${CONFIGURATION_KEYS.enableNaoRegRequirements.id}].booleanValue`, false)

  const isPrivacyPolicyAgreementEnabled = get(props, `configuration.values[${CONFIGURATION_KEYS.enablePrivacyPolicyAgreement.id}].booleanValue`, false)

  const naoRegRequirementUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.naoRegRequirementsUrl.id}].textValue`)

  const privacyPolicyUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.privacyPolicyUrl.id}].textValue`)

  const helpers = {
    photosConsent: requiredCheck(get(values, 'helpers.photosConsent')),
    terms: requiredCheck(get(values, 'helpers.terms')),
    agreementPrivacyPolicy: (isPrivacyPolicyAgreementEnabled && privacyPolicyUrl) && requiredCheck(get(values, 'helpers.agreementPrivacyPolicy')),
    agreementCodeOfConduct: (isVolunteerCodeOfConductEnabled && conductUrl) && requiredCheck(get(values, 'helpers.agreementCodeOfConduct'))
  }

  errors = {
    helpers: !isEmpty(helpers) && helpers
  }

  errors.email = required(get(values, 'email')) || email(get(values, 'email'))
  errors.passwordAgain = required(get(values, 'passwordAgain'))

  if (get(values, 'hierarchyLevel.value') !== HIERARCHY_LEVELS.IAC.id) {
    errors.helpers = {
      ...errors.helpers,
      naa: (isNaoRegRequirementEnabled && naoRegRequirementUrl) && requiredCheck(get(values, 'helpers.naa'))
    }
  }

  if (get(values, 'password') && get(values, 'passwordAgain')) {
    if (get(values, 'password') !== get(values, 'passwordAgain')) {
      errors = {
        ...errors,
        passwordAgain: {
          text: "Passwords don't match",
          intlKey: 'errors.passwords_dont_match',
          values: {}
        }
      }
    }
  }

  return errors
}

export default validate
